import tutorials from './tutorials'

export default [...tutorials]
